import { delay, put, select } from "redux-saga/effects";

import { breakpointValues } from "common/styles";
import { addCoachmarksToInDOM } from "domains/coachmarks/actions";
import { getCoachmarksAreEnabled, getCoachmarksInDOM } from "domains/coachmarks/selectors";
import { getCoachmarks } from "entities/coachmarks/selectors";

export function* initSaga() {
  let coachmarksAreActive = true;

  const mobileBreakpoint = window.matchMedia(`(max-width: ${breakpointValues.medium}px)`);

  while (coachmarksAreActive) {
    const coachmarks: ReturnType<typeof getCoachmarks> = yield select(getCoachmarks);
    const coachmarksInDOM: ReturnType<typeof getCoachmarksInDOM> = yield select(getCoachmarksInDOM);

    const isMobile = mobileBreakpoint.matches;

    const currentUnusedCoachmarksInDOM = coachmarks.reduce<string[]>(
      (ids, { target_selector, images, id }) =>
        document.querySelector(target_selector) !== null && (!isMobile || !!images) ? [...ids, id] : ids,
      [],
    );

    const coachmarksInDOMHaveChanged =
      coachmarksInDOM.length !== currentUnusedCoachmarksInDOM.length ||
      coachmarksInDOM.some((id) => !currentUnusedCoachmarksInDOM.includes(id));

    if (coachmarksInDOMHaveChanged) {
      yield put(addCoachmarksToInDOM({ ids: currentUnusedCoachmarksInDOM }));
    }
    yield delay(1000);
    coachmarksAreActive = yield select(getCoachmarksAreEnabled satisfies (...args: never[]) => boolean | null);
  }
}
